const parser = new DOMParser();

export default (html) => {
	const parsedToDocument = parser.parseFromString(html, 'text/html');
	const element = parsedToDocument.body.firstChild;
	element.toString = function toString() {
		return this.outerHTML;
	};
	return parsedToDocument.body.firstChild;
};
